import React from 'react';
import LazyloadImage from '../../../sharedComponents/LazyloadImage';

export type CardProps = {
    cardHeader: string;
    image: {
        altText?: string;
        imageUrl: string;
    };
    url: string;
};

export function InterlinkingCard({
    cardHeader,
    image,
    url,
    children,
}: React.PropsWithChildren<CardProps>) {
    return (
        <li>
            <a href={url}>
                <LazyloadImage
                    alt={image.altText ?? ''}
                    image={image.imageUrl}
                    style={{}}
                />
                <span>{cardHeader}</span>
                {!!children && <div>{children}</div>}
            </a>
        </li>
    );
}
